/** @jsxImportSource @emotion/react */
import tw from "twin.macro";

const Container = tw.div`absolute z-50 w-screen h-screen flex justify-center items-center bg-white `;
const SpinnerContainer = tw.div`relative h-16 w-16 border-8 border-solid border-gray-200 rounded-full flex justify-center items-center`;
const Spinner = tw.div`absolute h-full w-full border-8 border-solid border-red-500 border-t-transparent rounded-full animate-spin`;

export default () => {
  return (
    <Container>
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    </Container>
  );
};
